/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { withStyles } from 'material-ui/styles';

const styles = (theme) => ({
  content: {
    padding: theme.spacing.unit,
  },
  formContainer: {
    padding: theme.spacing.unit * 2,
    overflow: 'hidden',
    width: 'inherit',
  },
});

const QualificationIncomplete = ({ dispatch }) => (
  <div className='section'>
    <div className='max-width-div-center'>
      <h1 className='_2nd-header-copy'>Qualification Incomplete</h1>
      <div className='text-block-4-copy'>
        Select your Accreditation Type to access this section.
      </div>
      <button
        className='button-inline w-button'
        onClick={() => dispatch(push('/account/qualification'))}
      >
        Complete Qualification
      </button>
    </div>
  </div>
);

QualificationIncomplete.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default withStyles(styles)(QualificationIncomplete);



// WEBPACK FOOTER //
// ./src/components/Account/InvestorVerification/QualificationIncomplete.js